import { getters } from "./model";
import { makeInstanceSelector } from "redux-mvc";
import * as R from "ramda";
const getInstance = (_, props) => R.prop("instanceId", props);

export const isEditing = makeInstanceSelector(getters.isEditing, R.identity)(
  getInstance
);
